import { AfterViewInit, Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ModalController } from '@ionic/angular';
import Swiper from 'swiper';

@Component({
  selector: 'app-zoom-image-fullscreen',
  templateUrl: './zoom-image-fullscreen.page.html',
  styleUrls: ['./zoom-image-fullscreen.page.scss'],
})
export class ZoomImageFullScreenPage implements OnInit, AfterViewInit, OnDestroy {

  @Input() Imagen: string = '';

  @ViewChild('swiperZoom') swiperContainer: ElementRef | undefined;

  public slideOpts = {
    initialSlide: 0,
    allowTouchMove: false,
    zoom: {
      maxRatio: 5,
      minRatio: 1,
    },
    touchMoveStopPropagation: false,
    passiveListeners: false,
    preventClicksPropagation: true,
    virtual: {
      cache: true,
    },
    updateOnWindowResize: true,
  };
  public spinner: boolean = true;
  public swiperInstance: HTMLElement & { swiper?: Swiper } | undefined;

  constructor(private modalCtrl: ModalController) { }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    if (this.swiperContainer?.nativeElement) {
      this.swiperInstance = this.swiperContainer.nativeElement as HTMLElement & { swiper?: Swiper };
      Object.assign(this.swiperInstance, this.slideOpts);
      if (this.swiperInstance.swiper?.zoom) {
        this.swiperInstance.swiper.zoom.enable();
      }
    }
  }

  ngOnDestroy(): void {
    if (this.swiperInstance?.swiper) {
      this.swiperInstance.swiper.destroy();
    }
  }

  public onDismiss = (): Promise<boolean> => this.modalCtrl.dismiss(true);

  public ionSlidesDidLoad = (): boolean => (this.spinner = false);
}
